import { useState } from "react";
import { useAuthContext } from "@src/context";
import AdminHooks from "@src/context/hooks/adminHooks";
import { DropDown, Loader } from "@src/components/atoms";
import { CardContainer } from "@src/components/cards";
import { useAdminContext } from "@src/context/adminContext";
import VesselMonthSummaryTable from "./donationsTool/VesselMonthSummaryTable";
import DonationsSummary from "./donationsTool/DonationsSummary";
import DonationsRawTable from "./donationsTool/DonationsRawTable";

const DonationsToolTable = () => {
  const { role } = useAuthContext();
  const { customers, selectedCustomer } = useAdminContext();
  const [customerCode, setCustomerCode] = useState(
    selectedCustomer?.customerCode ?? "",
  );

  const { data, isPending, isError } = AdminHooks.useGetDonationsTool(
    role,
    customerCode,
  );

  const customerOptions = customers
    .map((c) => ({
      value: c.customerCode,
      text: `${c.name} (${c.customerCode})`,
    }))
    .sort((a, b) => a.text.localeCompare(b.text));

  const hasData =
    customerCode && !isPending && !isError && data?.rows?.length > 0;

  return (
    <CardContainer padding={8} allowOverflow>
      <div className="flex items-center gap-4 p-2 mb-4">
        <h4>Select a customer:</h4>
        <div className="w-80">
          <DropDown
            options={customerOptions}
            value={customerCode}
            onChange={setCustomerCode}
            enableSearch
          />
        </div>
      </div>

      <div className="min-h-[200px]">
        {!customerCode && (
          <div className="text-center text-neutral-400 py-8">
            Select a customer to view donations data
          </div>
        )}

        {customerCode && isPending && <Loader size="xl" />}

        {customerCode &&
          !isPending &&
          (isError || data?.rows?.length === 0) && (
            <div className="text-center py-8">
              No donations data found for this customer
            </div>
          )}

        {hasData && (
          <>
            <VesselMonthSummaryTable rows={data.rows} headers={data.headers} />
            <DonationsSummary rows={data.rows} headers={data.headers} />
            <DonationsRawTable rows={data.rows} headers={data.headers} />
          </>
        )}
      </div>
    </CardContainer>
  );
};

export default DonationsToolTable;
